import {NgModule} from '@angular/core';

import {} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {GLMMaterialDesignModule} from "../../_components/material-design/material-design.module";
import {DynamicBarModule} from "../../_components/dynamic-bar/dynamic-bar.module";
import {NavBarModule} from "../../_components/nav-bar/nav-bar.module";
import {NivelacionesReporteBarraComponent} from "./nivelaciones-reporte/nivelaciones-reporte-barra.component";
import {NivelacionesBarraComponent} from "./nivelaciones-barra.component";
import {NivelacionesDirectivoComponent} from "./nivelaciones-directivo/nivelaciones-directivo.component";
import {NivelacionesAlumnoBarraComponent} from "./nivelaciones-alumnos/nivelaciones-alumno-barra.component";
import {NivelacionesCitacionMcpBarraComponent} from "./citacion-materia-curso/nivelaciones-citacion-mcp-barra.component";
import {NivelacionesReporteComponent} from "./nivelaciones-reporte/nivelaciones-reporte.component";
import {NivelacionesDirectorCursoComponent} from "./nivelaciones-director-curso/nivelaciones-director-curso.component";
import {NivelacionesWidgetComponent} from "./nivelaciones-widget/nivelaciones-widget.component";
import {NivelacionesComponent} from "./nivelaciones.component";
import {CitacionMateriaCursoComponent} from "./citacion-materia-curso/citacion-materia-curso.component";
import {NivelacionesAlumnoComponent} from "./nivelaciones-alumnos/nivelaciones-alumno.component";
import {FechasNivelacionesPipe} from "../../_pipes/fechas-nivelaciones.pipe";
import {MateriaNivelacionesPipe} from "../../_pipes/materia-nivelaciones.pipe";
import {NivelacionesFiltroPipe} from "./_pipes/widget-nivelaciones-filtro.pipe";
import {NivelacionesFiltroHijosPipe} from "./_pipes/widget-nivelaciones-filtro-hijos.pipe";
import {NivelacionesRoutingModule} from "./nivelaciones-routing.module";
import {NivelacionesHomeComponent} from "./nivelaciones-home/nivelaciones-home.component";
import {NivelacionesReporteCursoComponent} from "./nivelaciones-reporte-curso/nivelaciones-reporte-curso.component";
import {NivelacionesConvencionesComponent} from "./nivelaciones-convenciones/nivelaciones-convenciones.component";
import {NivelacionesHijoComponent} from "./nivelaciones-hijo/nivelaciones-hijo.component";
import {NivelacionesWidgetPersonaComponent} from "./widget-persona/widget-persona.component";
import {GLMAppPipesModule} from "../_pipes/app-glm-pipes.module";
import {NivelacionesEspecialesComponent} from "./nivelaciones-especiales/nivelaciones-especiales.component";
import {CalendarWidgetModule} from "../../_components/calendar-widget/calendar-widget.module";
import {NivelacionesEspecialesAlumnosComponent} from "./nivelaciones-especiales-alumnos/nivelaciones-especiales-alumnos.component";
import {CustomPipesModule} from "../../_pipes/custom-pipes.module";

@NgModule({
    declarations: [
        //Nivelaciones
        NivelacionesHomeComponent,
        NivelacionesBarraComponent,
        NivelacionesCitacionMcpBarraComponent,
        NivelacionesReporteBarraComponent,
        NivelacionesAlumnoBarraComponent,
        NivelacionesComponent,
        CitacionMateriaCursoComponent,
        NivelacionesAlumnoComponent,
        NivelacionesDirectorCursoComponent,
        NivelacionesReporteComponent,
        NivelacionesWidgetComponent,
        NivelacionesDirectivoComponent,
        NivelacionesReporteCursoComponent,
        NivelacionesConvencionesComponent,
        FechasNivelacionesPipe,
        NivelacionesFiltroPipe,
        NivelacionesFiltroHijosPipe,
        MateriaNivelacionesPipe,
        NivelacionesHijoComponent,
        NivelacionesWidgetPersonaComponent,
        NivelacionesEspecialesComponent,
        NivelacionesEspecialesAlumnosComponent,
    ],
    imports: [
        CommonModule,
        FormsModule, //TODO: Usar reactive forms en los formularios existentes y remover esta dependencia.
        // HttpClientModule,
        ReactiveFormsModule,
        GLMMaterialDesignModule,
        NavBarModule,
        DynamicBarModule,
        GLMAppPipesModule.forRoot(),
        CalendarWidgetModule,
        CustomPipesModule,
        
        NivelacionesRoutingModule,
    ],
    exports: [
        NivelacionesWidgetComponent,
        NivelacionesFiltroPipe,
        NivelacionesFiltroHijosPipe,
        NivelacionesHijoComponent,
        NivelacionesWidgetPersonaComponent,
        NivelacionesConvencionesComponent
    ],
})
export class NivelacionesModule {
}
